import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";
import moment from 'moment';
import { Constants } from '../utils/Constants';

export const PlanogramService = {

    getPlanogramNamesForCurrentMerchantNotDeleted: () => {
        const url = `/portal/planograms/planogram-names`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    getList: (params = {}) => {
        const url = `/portal/planograms`;
        const queryParams = prepareBaseGetListParams(params);
        queryParams.append('only_active', params.showOnlyActive || false);
        return fetchWithAuth(`${url}?${queryParams}`, { method: 'GET' });
    },

    getStatusList: () => {
        const url = `/portal/planograms/status-list`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    getDetails: (planogramExternalId) => {
        const url = `/portal/planograms/${planogramExternalId}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    getDeactivatedParentPlanogramDetails: (planogramId) => {
        const url = `/portal/planograms/deactivate-details/${planogramId}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    isProductInPlanograms: (externalId) => {
        const url = `/portal/planograms/product/${externalId}/exists`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    create: (data) => {
        const url = `/portal/planograms`;
        return fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },

    update: (planogramExternalId, data) => {
        const url = `/portal/planograms/${planogramExternalId}`;
        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    },

  updateBasicInfo: (planogramExternalId, data) => {
      const url = `/portal/planograms/${planogramExternalId}/basic-info`;
      return fetchWithAuth(url, {
          method: 'PATCH',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              name: data?.name,
              externalSystemId: data?.externalSystemId
          })
      });
  },

    delete: (planogramExternalId) => {
        const url = `/portal/planograms/${planogramExternalId}`;
        return fetchWithAuth(url, { method: 'DELETE' });
    },

    deleteList: (criteria, selectedAll, exceptionIds) => {
        const params = prepareBaseGetListParams(criteria, false);
        if (criteria.healthState) {
            params.append('health_states', criteria.healthState);
        }
        return fetchWithAuth(`/portal/planograms/list?${params.toString()}`, { method: 'DELETE', body: JSON.stringify({ selectedAll, exceptions: exceptionIds }) });
    },

    activate: (planogramExternalId) => {
        const url = `/portal/planograms/${planogramExternalId}/activate`;
        return fetchWithAuth(url, { method: 'PUT' });
    },

    deactivate: (planogramExternalId) => {
        const url = `/portal/planograms/${planogramExternalId}/deactivate`;
        return fetchWithAuth(url, { method: 'PUT' });
    },

    deactivateAndReplaceParentPlanogram: (data) => {
        const url = `/portal/planograms/deactivate-and-replace`;
        const payload = {
            oldPlanogramExternalId: data.oldPlanogramExternalId,
            newPlanogramExternalId: data.newPlanogramExternalId || null,
            assignedDevicesExternalIds: data.assignedDevicesExternalIds || [],
            clearCells: data.clearCells || false,
            effectiveDate: data.effectiveDate 
                ? moment(data.effectiveDate).format(Constants.DATE_FORMAT)
                : null
        };
        return fetchWithAuth(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    },

    duplicate: (planogramExternalId) => {
        const url = `/portal/planograms/${planogramExternalId}/duplicate`;
        return fetchWithAuth(url, { method: 'POST' });
    },

    //Deprecated
    getActiveInitializedDevicesByLayout: (columns, rows) => {
        const url = `/portal/planograms/active-devices-by-layout`;
        const params = new URLSearchParams();
        params.append('columns', columns);
        params.append('rows', rows);
        return fetchWithAuth(`${url}?${params}`, { method: 'GET' });
    },

    addDevicesToPlanogram: (planogramExternalId, deviceIds, implementationDate, applyImmediately) => {
        const url = `/portal/planograms/add-devices-to-planogram/${planogramExternalId}`;
        const effectiveImplementationDate = implementationDate || new Date();
        const payload = {
            deviceIds,
            applyImmediately: Boolean(applyImmediately),
            implementationDate: moment(effectiveImplementationDate).format(Constants.DATE_FORMAT)
        };
        return fetchWithAuth(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    },

    isAssigned: (planogramId) => {
        const url = `/portal/planograms/${planogramId}/assigned`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    deviceListByPlanogramProduct: (criteria) => {
        const url = `/portal/planograms/device-list-by-planogram-product`;
        const params = prepareBaseGetListParams(criteria);
        if (criteria.productExternalId) {
            params.append('product_external_id', criteria.productExternalId);
        }
        if (criteria.deviceId) {
            params.append('device_id', criteria.deviceId);
        }
        if (criteria.locationName) {
            params.append('location_name', criteria.locationName);
        }
        if (criteria.deviceName) {
            params.append('device_name', criteria.deviceName);
        }
        if (criteria.assignmentTo) {
            params.append('assignment_to', criteria.assignmentTo);
        }
        if (criteria.planogramName) {
            params.append('planogram_name', criteria.planogramName);
        }
        return fetchWithAuth(`${url}?${params.toString()}`, { method: 'GET' });
    },


    
    // getTechniciansList: () => {
    //     return fetchWithAuth('/portal/locations/technicians-list', { method: 'GET' });
    // },
}